/// <reference types="@types/googlemaps" />
/*global google*/

// const autocompleteService = new google.maps.places.AutocompleteService();

function createAutocompleteRequest(input, sessionToken, location) {

  let result = {
    input,
    types: ["address"]
  };
  if (sessionToken != null) {
    result.sessionToken = sessionToken;
  }
  if (location != null) {
    const latlng = new google.maps.LatLng(location.lat, location.lng);
    result.location = latlng;
    result.radius = 20000;
  }
  return result;
}

function createPlacesRequest(placeId, sessionToken) {
  let result = {
    fields: ['address_components', 'formatted_address', 'geometry', 'place_id', 'url'],
    placeId: placeId
  };
  if (sessionToken != null) {
    result.sessionToken = sessionToken;
  }
  return result;
}

function generateAddressFromPlaceDetail(addressComponents) {
  let address = {};
  let numberComponent = addressComponents.find(el => el.types.indexOf('street_number') !== -1);
  let number = (numberComponent && numberComponent.long_name) || 'NO_NUMBER';

  let routeComponent = addressComponents.find(el => el.types.indexOf('route') !== -1);
  let route = (routeComponent && routeComponent.long_name) || 'NO_ROUTE';
  let routeShort = (routeComponent && routeComponent.short_name) || 'NO_ROUTE';

  let cityComponent = addressComponents.find(el => el.types.indexOf('locality') !== -1);
  let city = (cityComponent && cityComponent.long_name) || 'NO_CITY';

  let countyComponent = addressComponents.find(el => el.types.indexOf('administrative_area_level_2') !== -1);
  let county = (countyComponent && countyComponent.long_name) || 'NO_COUNTY';

  let stateComponent = addressComponents.find(el => el.types.indexOf('administrative_area_level_1') !== -1);
  let state = (stateComponent && stateComponent.short_name) || 'NO_STATE';

  let zipCodeComponent = addressComponents.find(el => el.types.indexOf('postal_code') !== -1);
  let zipcode = (zipCodeComponent && zipCodeComponent.long_name) || 'NO_ZIPCODE';

  address.streetAddress = `${number} ${route}`;
  address.streetAddressShort = `${number} ${routeShort}`;
  address.city = city;
  address.state = state;
  address.county = county;
  address.zipCode = zipcode;

  return address;
}

export function getSessionToken() {
  return new google.maps.places.AutocompleteSessionToken();
}

export function getPropertySuggestions(input, sessionToken = null, location = null) {
  const request = createAutocompleteRequest(input, sessionToken, location);
  const autocompleteService = new google.maps.places.AutocompleteService();
  return new Promise((resolve, reject) => {
    autocompleteService.getPlacePredictions(request, (predictions, status) => {
      switch (status) {
        case "OK":
          resolve(predictions);
          break;
        case "NOT_FOUND":
          console.warn("status: NOT_FOUND");
          resolve([]);
          break;
        case "ZERO_RESULTS":
          console.warn("status: ZERO_RESULTS");
          resolve([]);
          break;
        default:
          console.error(status);
          reject();
      }
    });
  });
}
export function getPlaceDetails(placeId, sessionToken = null) {
  const request = createPlacesRequest(placeId, sessionToken);
  // PlacesServices needs a google maps map object passed in params
  let tempMap = new google.maps.Map(document.createElement('div'));
  const placeService = new google.maps.places.PlacesService(tempMap);
  return new Promise((resolve, reject) => {
    placeService.getDetails(request, (place, status) => {
      switch (status) {
        case "OK":
          // configure address result
          let address = generateAddressFromPlaceDetail(place.address_components);
          let location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
          resolve({
            success: true,
            data: {
              address: address,
              location: location,
              ...place
            }
          });
          break;
        case "NOT_FOUND":
          console.warn("status: NOT_FOUND");
          resolve({
            success: false,
            message: "status: NOT_FOUND"
          });
          break;
        case "ZERO_RESULTS":
          console.warn("status: ZERO_RESULTS");
          resolve({
            success: false,
            message: "status: ZERO_RESULTS"
          });
          break;
        default:
          console.error(status);
          reject({
            success: false,
            message: "Failed to get place details"
          });
      }
    });
  });
}